<template>
  <div>
    <!-- ホスト名 -->
    <v-row>
      <v-col class="pb-0" cols="12">
        <v-text-field
          v-model="host"
          :label="$t(`form.jobSetting.jobTask.host`)"
          name="host"
          :data-vv-as="$t(`form.jobSetting.jobTask.host`)"
          v-validate="'required'"
          :error-messages="errors.collect('host')" />
      </v-col>
    </v-row>
    <!-- ポート番号 -->
    <v-row>
      <v-col class="pb-0" cols="12">
        <v-text-field
          v-model="port"
          :label="$t(`form.jobSetting.jobTask.port`)"
          type="number"
          name="port"
          :data-vv-as="$t(`form.jobSetting.jobTask.port`)"
          v-validate="'required'"
          :error-messages="errors.collect('port')" />
      </v-col>
    </v-row>
    <!-- ユーザー名 -->
    <v-row>
      <v-col class="pb-0" cols="12">
        <v-text-field
          v-model="user"
          :label="$t(`form.jobSetting.jobTask.user`)"
          name="user"
          :data-vv-as="$t(`form.jobSetting.jobTask.user`)"
          v-validate="'required'"
          :error-messages="errors.collect('user')" />
      </v-col>
    </v-row>
    <!-- パスワード -->
    <v-row>
      <v-col class="pb-0" cols="12">
        <v-text-field
          v-model="password"
          autocomplete="new-password"
          type="password"
          :label="$t(`form.password`)"
          name="password"
          :data-vv-as="$t(`form.password`)"
          v-validate="'required'"
          :error-messages="errors.collect('password')" />
      </v-col>
    </v-row>
    <!-- データベース名 -->
    <v-row>
      <v-col class="pb-0" cols="12">
        <v-text-field
          v-model="database"
          :label="$t(`form.jobSetting.jobTask.database`)"
          name="database"
          :data-vv-as="$t(`form.jobSetting.jobTask.database`)"
          v-validate="'required'"
          :error-messages="errors.collect('database')" />
      </v-col>
    </v-row>
    <!-- スキーマ名 -->
    <v-row>
      <v-col class="pb-0" cols="12">
        <v-text-field
          v-show="etlType === INPUT_ETL_TYPES.REDSHIFT.value"
          v-model="schema"
          :label="$t(`form.jobSetting.jobTask.schema`)"
          name="schema">
          <v-tooltip slot="append" bottom :max-width="400">
            <template #activator="{ on }">
              <v-icon v-on="on">ic-help-S</v-icon>
            </template>
            <span v-html="$t(`tooltip.jobSetting.jobTaskSchema`)" />
          </v-tooltip>
        </v-text-field>
      </v-col>
    </v-row>
    <!-- テーブル名 -->
    <v-row>
      <v-col class="pb-0" cols="12">
        <v-text-field
          v-model="table"
          :label="$t(`form.jobSetting.jobTask.table`)"
          name="table"
          :data-vv-as="$t(`form.jobSetting.jobTask.table`)"
          v-validate="'required'"
          :error-messages="errors.collect('table')" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import INPUT_ETL_TYPES from '@/enum/jobTask/INPUT_ETL_TYPES'
import JSON_INPUT_ITEM_NAMES from '@/enum/jobTask/JSON_INPUT_ITEM_NAMES'

const TOOLTIP_WIDTH = 400

export default {
  props: ['etlType', 'inputForm'],
  mixins: [INPUT_ETL_TYPES, JSON_INPUT_ITEM_NAMES],
  data () {
    return {
      tooltipWidth: TOOLTIP_WIDTH,
    }
  },
  computed: {
    host: {
      get () {
        if (this.checkSettingProp()) {
          return this.getInputJson().host
        }
        return null
      },
      set (value) {
        this.updateValue('host', value)
      },
    },
    port: {
      get () {
        if (this.checkSettingProp()) {
          return this.getInputJson().port
        }
        return null
      },
      set (value) {
        this.updateValue('port', value)
      },
    },
    user: {
      get () {
        if (this.checkSettingProp()) {
          return this.getInputJson().user
        }
        return null
      },
      set (value) {
        this.updateValue('user', value)
      },
    },
    password: {
      get () {
        if (this.checkSettingProp()) {
          return this.getInputJson().password
        }
        return null
      },
      set (value) {
        this.updateValue('password', value)
      },
    },
    schema: {
      get () {
        if (this.checkSettingProp()) {
          return this.getInputJson().schema
        }
        return null
      },
      set (value) {
        this.updateValue('schema', value)
      },
    },
    database: {
      get () {
        if (this.checkSettingProp()) {
          return this.getInputJson().database
        }
        return null
      },
      set (value) {
        this.updateValue('database', value)
      },
    },
    table: {
      get () {
        if (this.checkSettingProp()) {
          return this.getInputJson().table
        }
        return null
      },
      set (value) {
        this.updateValue('table', value)
      },
    },
  },
  methods: {
    /**
     * タスクのインプット種別がAuroraまたはRedshiftの判定
     * @return {Boolean}
     */
    checkSettingProp () {
      if (this.etlType === this.INPUT_ETL_TYPES.AURORA.value) {
        return this.inputForm && this.inputForm[this.JSON_INPUT_ITEM_NAMES.AURORA.value]
      } else if (this.etlType === this.INPUT_ETL_TYPES.REDSHIFT.value) {
        return this.inputForm && this.inputForm[this.JSON_INPUT_ITEM_NAMES.REDSHIFT.value]
      }
      return false
    },
    /**
     * JSONからタスクの値を取得
     * @return {Object}
     */
    getInputJson () {
      if (this.etlType === this.INPUT_ETL_TYPES.AURORA.value) {
        return this.inputForm[this.JSON_INPUT_ITEM_NAMES.AURORA.value]
      } else if (this.etlType === this.INPUT_ETL_TYPES.REDSHIFT.value) {
        return this.inputForm[this.JSON_INPUT_ITEM_NAMES.REDSHIFT.value]
      }
      return null
    },
    /**
     * タスクの値更新処理呼び出し
     * @param  {String} propertyName  更新対象の項目名
     * @param  {String} propertyValue 更新対象の値
     */
    updateValue (propertyName, propertyValue) {
      if (!this.inputForm || !this.etlType) return

      if (this.etlType === this.INPUT_ETL_TYPES.AURORA.value) {
        this.updateValueByJsonItemName(propertyName, propertyValue, this.JSON_INPUT_ITEM_NAMES.AURORA.value)
      } else if (this.etlType === this.INPUT_ETL_TYPES.REDSHIFT.value) {
        this.updateValueByJsonItemName(propertyName, propertyValue, this.JSON_INPUT_ITEM_NAMES.REDSHIFT.value)
      }
    },
    /**
     * JSONに変換してタスクの値を更新
     * @param  {String} propertyName  更新対象のキー
     * @param  {String} propertyValue 更新対象の値
     * @param  {String} jsonItemName  更新対象のインプット種別
     */
    updateValueByJsonItemName (propertyName, propertyValue, jsonItemName) {
      const json = Object.assign({}, this.inputForm)
      if (!json[jsonItemName]) {
        this.$set(json, jsonItemName, {})
      }
      Object.assign(json[jsonItemName], { [propertyName]: propertyValue })
      this.$emit('update', json)
    },
  },
}
</script>
